<template>
  <v-container class="fill-height" fluid>
    <v-overlay z-index="1000">
      <v-card class="text-center black--text" color="white">
        <v-card-title>{{ $tt('customOAuthMessage') }}</v-card-title>
        <v-card-text>
          <v-progress-circular color="primary" indeterminate size="64"></v-progress-circular>
        </v-card-text>
      </v-card>
    </v-overlay>
  </v-container>
</template>

<script>
import connectManagerClient from '@/lib/connect-client/connect-manager-client'
import storage from '@/lib/storage'
import axios from 'axios'
import * as Constants from '@/lib/constants'
import Multipassify from 'multipassify'

export default {
  mounted() {
    this.checkRefreshToken()
  },
  methods: {
    checkRefreshToken() {
      let refreshToken = storage.getRefreshToken()
      if (refreshToken) {
        this.getIpAddress()
      } else {
        this.$router.push({ name: 'Login', query: { redirect: '/sso/shopify' } })
      }
    },
    getIpAddress() {
      axios
        .post('https://ipinfo.io/?callback')
        .then(response => {
          this.sso(response.data.ip)
        })
        .catch(error => {
          console.error(error)
        })
    },
    sso(ip) {
      let refreshToken = storage.getRefreshToken()
      connectManagerClient
        .refreshAccessToken()
        .then(response => {
          const userInfo = response.data.userInfo
          let params = {
            email: userInfo.email,
            remote_ip: ip,
          }
          const returnUrl = this.$route.query.return_url
          if (returnUrl === 'cart') {
            params.return_to = Constants.SHOPIFY_URL + 'cart'
          }
          if (returnUrl === 'top') {
            params.return_to = Constants.SHOPIFY_URL
          }
          if (returnUrl === 'en-us') {
            params.return_to = Constants.SHOPIFY_URL + 'en-us'
          }
          const multipassify = new Multipassify(Constants.SHOPIFY_SSO_KEY)
          const url = multipassify.generateUrl(params, Constants.SHOPIFY_DOMAIN)
          this.open(url)
        })
        .catch(error => {
          console.error(error)
        })
    },
    open(url) {
      window.location.href = url
    },
  },
}
</script>
